import React from 'react';
import { ProductEditViewStore } from 'modules/product/stores';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { WizardContainerTemplate } from 'themes/modules/product/wizard/pages';

@setCurrentView(rootStore => new ProductEditViewStore(rootStore), 'productEditViewStore')
@observer
class ProductEdit extends React.Component {
	render() {
		const {
			productEditViewStore,
			productEditViewStore: { form, productId, applyToAllActiveOrdersConfirmModal, loading, handleBackButtonClick },
		} = this.props;

		return (
			<WizardContainerTemplate
				viewStore={productEditViewStore}
				itemName={productId ? 'PRODUCT.UPDATE' : 'PRODUCT.CREATE'}
				stepForm={form}
				applyToAllActiveOrdersConfirmModal={applyToAllActiveOrdersConfirmModal}
				disabled={loading}
				goBack={handleBackButtonClick}
			/>
		);
	}
}

export default ProductEdit;
